export default class TrackingService {

    constructor() {
        /*🤫*/
        this.global = window.o_global
        this.global = window.o_global || {};
        if (!this.global.eventQBus) {
            this.global.eventQBus = {
                emit: () => {
                    if (window.o_global.debug.status().activated) {
                        console.log("Tracking not available.");
                    }
                }
            }
        }

        /*🤫*/
        this.util = window.o_util || {};
        if (!this.util.o_util) {
            this.util.o_util = {
                misc: {
                    getPagecluster: () => {
                        if (window.o_global.debug.status().activated) {
                            console.log("Tracking not available.");
                        }
                    }
                }
            }
        }
    }

    sendSmallShoppromoInitialViewTrackingEvent(featureOrder, featureIndex, personalizationContext, tiles, visibleTiles, masFeatureTrackingLabels) {
        let trackingData = [this._createSmallShoppromoLabel(featureOrder, featureIndex, tiles.length, personalizationContext, "loaded", masFeatureTrackingLabels)];
        [].map.call(tiles.slice(0, visibleTiles), tile => {
            tile.setIsTracked();
            trackingData.push(this._createSmallShoppromoTileLabel(tile.position, featureIndex, tile.featureTrackingLabels, tile.variationId, "loaded"))
        });
        this.global.eventQBus.emit("tracking.bct.addFeaturesToPageImpression", trackingData);
    }

    sendSmallShoppromoClickTrackingEvent(featureOrder, featureIndex, personalizationContext, filledSlots, tile, masFeatureTrackingLabels) {
        const featureTracking = [];
        featureTracking.push(this._createSmallShoppromoLabel(featureOrder, featureIndex, filledSlots, personalizationContext, "clicked", masFeatureTrackingLabels));
        featureTracking.push(this._createSmallShoppromoTileLabel(tile.position, featureIndex, tile.featureTrackingLabels, tile.variationId, "clicked"));
        let pageCluster = window.o_util.misc.getPagecluster();
        let labelTrackingData = {}
        labelTrackingData["wk.promo_AttributionFeature"] = `ShopPromotionSmall_${pageCluster}`;
        labelTrackingData["wk.promo_AttributionSource"] = tile.teslaModel;

        this.global.eventQBus.emit('tracking.bct.submitMoveAction', labelTrackingData, {
            name: "click",
            features: featureTracking
        });
        this.global.eventQBus.emit("tracking.bct.trackOnNextPageImpression", {"promo_Click": "ShopPromotionSmall"});
    }

    sendViewTrackingEventForCinemaMovement(featureOrder, featureIndex, tiles, personalizationContext, startIndex, endIndex, movementType, masFeatureTrackingLabels) {
        const featureTracking = [];
        [].map.call(tiles.slice(startIndex, endIndex + 1), tile => {
            if (!tile.isTracked()) {
                tile.setIsTracked();
                featureTracking.push(this._createSmallShoppromoTileLabel(tile.position, featureIndex, tile.featureTrackingLabels, tile.variationId, "loaded"));
            }
        });

        featureTracking.push(this._createSmallShoppromoLabel(featureOrder, featureIndex, tiles.length, personalizationContext, "loaded", masFeatureTrackingLabels))
        this.global.eventQBus.emit('tracking.bct.submitAction', {}, {
            name: movementType,
            features: featureTracking
        });
    }

    _createSmallShoppromoLabel(featureOrder, featureIndex, filledSlots, personalizationContext, status, masFeatureTrackingLabels) {
        let labels = {};
        labels.promo_FeatureNumber = [(featureIndex + 1).toString()];
        labels.promo_FilledSlots = [(filledSlots).toString()];
        labels.promo_Feature = ["true"];
        personalizationContext ? labels.promo_Context = [personalizationContext] : null;

        return {
            id: 'ft3_spsnf' + featureIndex,
            name: "ShopPromotionSmall",
            position: featureOrder,
            status: status,
            labels: {
                ...labels,
                ...masFeatureTrackingLabels
            }
        }
    }

    _createSmallShoppromoTileLabel(positionInSlider, featureIndex, tileLabels, variationIdOfImage, status) {
        let trackingPayload = {
            id: "ft3_spsnf" + featureIndex + "_tile" + positionInSlider,
            parentId: "ft3_spsnf" + featureIndex,
            name: "ShopPromotionSmall-Tile",
            position: positionInSlider,
            status: status,
            labels: tileLabels
        };

        if (variationIdOfImage) {
            trackingPayload.variationId = variationIdOfImage;
        } else {
            trackingPayload.variationId = "none";
        }

        return trackingPayload
    }

}
